export default {
  state: {
    DriverList: null,
    driverTotalCount: null,
    driverSingle: null
  },
  mutations: {
    setDriverList (state, payload) {
      state.DriverList = payload
    },
    setDriverTotalCount (state, payload) {
      state.driverTotalCount = payload
    },
    setDriverSingle (state, payload) {
      state.driverSingle = payload
    }
  },
  actions: {
    getDriverList ({commit, dispatch}, data) {
      let date = '&date=' + data.date
      let branchId = data.branchId !== null ? '&branch_id=' + data.branchId : ''
      let filialId = data.filialId !== null ? '&filial_id=' + data.filialId : ''
      let offset = data.offset !== null ? '&offset=' + data.offset : ''
      let limit = data.limit !== null ? '&limit=' + data.limit : ''
      const url = '/admin/driver/list?access_token=' + this.getters.accessToken + date + branchId + filialId + offset + limit

      dispatch('apiGet', url)
        .then((data) => {
          commit('setDriverList', data.driver_list)
          commit('setDriverTotalCount', data.total_count)
        })
        .catch((error) => {
          throw error
        })
    },
    getDriverSingle ({commit, dispatch}, {id, date}) {
      const url = '/admin/driver/' + id + '/single?access_token=' + this.getters.accessToken + '&date=' + date
      dispatch('apiGet', url)
        .then((data) => {
          commit('setDriverSingle', data)
        })
        .catch((error) => {
          throw error
        })
    }
  },
  getters: {
    DriverList (state) {
      return state.DriverList
    },
    driverTotalCount (state) {
      return state.driverTotalCount
    },
    driverSingle (state) {
      return state.driverSingle
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/driver.js